import React from 'react';
import PlacesAutocomplete, { geocodeByPlaceId } from 'react-places-autocomplete';
import R from 'ramda';

export default ({ updateLocationProps, contactInfo, style, isSingleLoc }) => {
  return (
    <div style={Object.assign({}, { padding: '4px 8px 8px', backgroundColor: '#efefef' }, style)}>
      <small style={{ marginBottom: '6px', display: 'block' }}>You only need to enter below information once for {R.call(R.cond([
        [() => isSingleLoc, R.always('your business')],
        [R.T, R.always('this property/location')],
      ]))}, and you can update it later by going to the <b>Profile</b>.</small>
      <label style={{ display: 'block' }}>Primary Contact: <small style={{ color: 'red' }}>* All fields required</small></label>
      <div className="flex-tc-sb">
        <div>
          <small>First Name</small><br/>
          <input style={{ width: '100%' }} value={contactInfo.firstName || ''} onChange={e => updateLocationProps({ contactInfo: { ...contactInfo, firstName: e.target.value } })} /><br/>
        </div>
        <div>
          <small>Last Name</small><br/>
          <input style={{ width: '100%' }} value={contactInfo.lastName || ''} onChange={e => updateLocationProps({ contactInfo: { ...contactInfo, lastName: e.target.value } })} /><br/>
        </div>
        <div>
          <small>Phone</small><br/>
          <input style={{ width: '100%' }} value={contactInfo.phone || ''} onChange={e => updateLocationProps({ contactInfo: { ...contactInfo, phone: e.target.value } })} /><br/>
        </div>
      </div>
      <label>Address</label><small style={{ color: 'red' }}>* Required</small>
      <PlacesAutocomplete
        onSelect={(address, placeId) => {
          geocodeByPlaceId(placeId).then(([results]) => {
            const addressToReturn = {};
            if (results) {
              addressToReturn.address_1 = results.formatted_address.split(',')[0];
              addressToReturn.formattedAddress = results.formatted_address;
              const coordinates = [results.geometry.location.lng(), results.geometry.location.lat()];
              addressToReturn.coordinates = coordinates;
              addressToReturn.loc = { coordinates };
              results.address_components.forEach(component => {
                if (R.contains('locality', component.types)) addressToReturn.city = component.long_name;
                if (R.contains('administrative_area_level_1', component.types)) addressToReturn.state = component.long_name;
                if (R.contains('postal_code', component.types)) addressToReturn.postal_code = component.long_name;
                if (R.contains('country', component.types)) addressToReturn.country = component.long_name;
              });
            }
            updateLocationProps({
              contactInfo: {
                ...contactInfo,
                address: addressToReturn,
              },
            });
          });
        }}
        onEnterKeyDown={address => updateLocationProps({ contactInfo: R.merge(contactInfo, { address }) })}
        autocompleteItem={({ formattedSuggestion }) => (
          <div>
            <strong>{ formattedSuggestion.mainText }</strong>{' '}
            <small>{ formattedSuggestion.secondaryText }</small>
          </div>)}
        styles={{
          root: { width: '100%' },
          input: {
            padding: '0',
          },
          googleLogoContainer: { boxShadow: '0 2px 4px rgba(0,0,0,0.2)' },
          autocompleteContainer: {
            position: 'none',
            height: '200px',
            width: '100%',
            zIndex: '14000 !important',
            border: '1px solid #e6e6e6',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            borderRadius: '0 0 2px 2px',
          },
        }}
        inputProps={{
          type: 'text',
          value: R.pathOr('', ['address', 'formattedAddress'], contactInfo) || R.pathOr('', ['address', 'address_1'], contactInfo),
          onChange: addressTyped => {
            updateLocationProps({
              contactInfo: {
                ...contactInfo,
                address: R.merge(contactInfo.address || {}, { formattedAddress: addressTyped, address_1: addressTyped }),
              },
            });
          },
          autoFocus: true,
        }}
      />
      {
        // location.products && location.products.map((product, productIndex) => (
        //   <div style={{ display: 'flex', alignItems: 'center' }}>
        //     <Checkbox
        //       checked={Boolean(product.name)}
        //       disabled={!Boolean(product.name)}
        //       style={{ width: '44px' }}
        //       onCheck={() => {
        //         const immutableNewLocs = fromJS(locations).setIn([locationIndex, 'products', productIndex, 'name'], '');
        //         updateProps({
        //           locations: immutableNewLocs,
        //         });
        //       }}
        //     />
        //     <TextField
        //       id={`newProductName${productIndex}${locationIndex}`}
        //       defaultValue={product.name}
        //       hintText="Enter your product name"
        //       onChange={(_, val) => {
        //         const immutableNewLocs = fromJS(locations).setIn([locationIndex, 'products', productIndex, 'name'], val);
        //         updateProps({
        //           locations: immutableNewLocs,
        //         });
        //       }}
        //     />
        //   </div>
        // ))
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/components/location-contact-info-form.jsx